import { Palette } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CompactThemeSelect } from "@/components/ui/theme-toggle";
import { FullLanguageSelector } from "@/lib/components/i18n/language-selector";

export function AppearanceCard() {
  const { t } = useTranslation("settings");

  return (
    <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
            <Palette className="w-4 h-4 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-foreground">{t("appearance.title")}</h3>
            <p className="text-sm text-muted-foreground break-words">
              {t("sections.appearance.description")}
            </p>
          </div>
        </div>

        {/* Language Selection */}
        <div className="space-y-3">
          <h4 className="text-sm font-medium text-foreground">{t("appearance.language")}</h4>
          <div className="flex justify-start">
            <FullLanguageSelector />
          </div>
        </div>

        {/* Theme Selection */}
        <div className="space-y-3">
          <h4 className="text-sm font-medium text-foreground">{t("appearance.theme")}</h4>
          <CompactThemeSelect />
        </div>
      </div>
    </div>
  );
}
